import * as Utils from '@utils'

export default {
  install: (app) => {
    app.config.globalProperties.$utils = Utils

    app.provide('utils', Utils)
  }
}